export default {
    LOAD_ENTRANCE_EXIT_PREVIEW(state, entrance_exit_preview) {
        state.items = entrance_exit_preview
    }
}